import React, {Component} from 'react';
import {connect} from 'react-redux';
import Head from '../../../Structure/components/Head/Head';
import Alert from 'react-s-alert';
import AlertsConteiner from '../../../Shared/components/Alerts/AlertsConteiner';
import Input from '../../../Shared/components/Forms/input/input';
import WaitBlock from "../../../Shared/components/Alerts/WaitBlock";
import Timeline from '../../../Shared/components/Info/Timeline';
import {changeStepWaitBlock, showWaitBlock} from "../../../Structure/actions/actionsStructure";
import {checkIsLogin, signUp} from "../../../AdminProtectora/actions/actionsAdmin";
import {browserHistory} from 'react-router';
import PoliticaCheckButton from '../../../Shared/components/components/PoliticaCheckButton/PoliticaCheckButton';
import {loadTiposEntidad} from '../../../AnimalList/actions/actionsFilterAnimals';
import SimpleSelect from "../../../Shared/components/Forms/selects/SimpleSelect";
import InputPassword from "../../../Shared/components/Forms/input/inputPassword";
import {PATH_BUSCADOR_ANIMALES_ADMIN} from "../../../../App/RouterAdopta";


class RegistroProtectoraPage extends Component {
    
    constructor(props) {
        super(props);
        this.props.isLogin();
        
        this.info = [
            {
                title: "Registrarse",
                description: "Introduce los datos de tu protectora o asociación en el formulario.",
                srcImageDescription: process.env.CDN_URL + "/images/adoptaunanimal/timelineSignup/addProtectora.100x100.png"
                // srcImageDescription: getImageEncode("addProtectora.100x100")
            },
            {
                title: "Verificación",
                description: "Recibirás un email de confirmación.",
                srcImageDescription: process.env.CDN_URL + "/images/adoptaunanimal/timelineSignup/emailFlat.png"
                // srcImageDescription: getImageEncode("emailFlat.125x125")
            },
            {
                title: "Todo listo",
                description: "Y ya podrás subir tus animales a la plataforma.",
                srcImageDescription: process.env.CDN_URL + "/images/adoptaunanimal/timelineSignup/dog.100x100.png"
                // srcImageDescription: getImageEncode("dog.100x100")
            },
        ];
        
        this.initialState = {
            name: "",
            password: "",
            email: "",
            emailIsHotmail: false,
            codPostal: "",
            localidad: "",
            provincia: "",
            nif: "",
            direccion: "",
            direccionNoExacta: "",
            ocultarDireccionExacta: false,
            contratoMunicipal: false,
            mostrarRRSS: false,
            motivoOcultarDir: "",
            numDir: "",
            facebook: "",
            instagram: "",
            twitter: "",
            URL: "",
            descripcion: "",
            realizaEnvios: false,
            address: {},
            colaboradores: [{
                nombre: "",
                email: "",
                telefono: "",
                WhatsApp: true,
                funcion: ""
            }],
            loaded: false,
            okPolitica: false,
            imageData: {},
            tipoEntidad: "",
            otroTipoEntidad: ""
        };
        
        this.state = this.initialState;
        
        this.Registrar = this.Registrar.bind(this);
        this.loadConfig = this.loadConfig.bind(this);
        this.imageChange = this.imageChange.bind(this);
        
        this.name = {
            inlineIcon: "form-control-inline-icon inline-icon-right",
            controlValidate: "validateRegis",
            iconSpan: "icon-registro las la-paw",
            columns: "col-lg-12",
            id: "name",
            type: "text",
            placeHolder: "*Nombre de protectora o asociación",
            methodChange: this.changeName.bind(this)
        };
        
        
        this.configTipoEntidad = {
            id: "tipoEntidad",
            idSelect: "tiposEntidad",
            collSize: "col-lg-12",
            seleccionado: this.state.tipoEntidad,
            placeHolder: "Tipo entidad",
            methodChange: this.changeTipoEntidad.bind(this)
        };
        
        this.configOtroTipoEntidad = {
            inlineIcon: "form-control-inline-icon inline-icon-right",
            controlValidate: "validateRegis",
            iconSpan: "icon-registro las la-tags",
            columns: "col-lg-12",
            id: "otroTipoEntidad",
            type: "text",
            placeHolder: "*Indique el tipo de entidad",
            methodChange: this.changeOtroTipoEntidad.bind(this)
        };
        
        this.nif = {
            inlineIcon: "form-control-inline-icon inline-icon-right",
            controlValidate: "validateRegis",
            iconSpan: "icon-registro las la-briefcase",
            columns: "col-lg-12",
            id: "nif",
            type: "text",
            placeHolder: "*NIF/CIF/Nº de asociación",
            // maxlength: 9,
            methodChange: this.changeNif.bind(this)
        };
        
        this.password = {
            inlineIcon: "form-control-inline-icon inline-icon-right",
            controlValidate: "validateRegis",
            iconSpan: "icon-registro las la-key",
            columns: "col-lg-12",
            id: "password",
            type: "password",
            placeHolder: "*Contraseña",
            methodChange: this.changePassword.bind(this)
        };
        
        this.email = {
            inlineIcon: "form-control-inline-icon inline-icon-right",
            controlValidate: "validateRegis",
            iconSpan: "icon-registro las la-envelope",
            columns: "col-lg-12",
            id: "email",
            type: "username",
            placeHolder: "*Email de protectora o asociación",
            methodChange: this.changeEmail.bind(this)
        };
        
        this.codPostal = {
            inlineIcon: "form-control-inline-icon inline-icon-right",
            controlValidate: "validateRegis",
            iconSpan: "icon-registro las la-address-card",
            columns: "col-lg-12",
            id: "codPostal",
            type: "text",
            placeHolder: "*Código postal",
            maxlength: 5,
            numericKeyPress: true,
            methodChange: this.changeCodPostal.bind(this),
            blurMethod: this.blurCodPostal.bind(this)
        };
        
        this.localidad = {
            inlineIcon: "form-control-inline-icon inline-icon-right",
            controlValidate: "validateRegis",
            iconSpan: "icon-registro las la-home",
            columns: "col-lg-12",
            id: "localidad",
            type: "text",
            placeHolder: "Localidad",
            readOnly: true,
            methodChange: this.changeLocalidad.bind(this)
        };
        
        this.provincia = {
            inlineIcon: "form-control-inline-icon inline-icon-right",
            controlValidate: "validateRegis",
            iconSpan: "icon-registro las la-city",
            columns: "col-lg-12",
            id: "provincia",
            type: "text",
            placeHolder: "Provincia",
            readOnly: true,
            methodChange: this.changeProvincia.bind(this)
        };
        
        this.direccion = {
            inlineIcon: "form-control-inline-icon inline-icon-right",
            controlValidate: "validateRegis",
            iconSpan: "icon-registro las la-road",
            columns: "col-lg-8",
            id: "direccion",
            type: "text",
            placeHolder: "*Calle (indica el tipo de vía)",
            methodChange: this.changeDireccion.bind(this)
        };
        
        this.num_dir = {
            inlineIcon: "form-control-inline-icon inline-icon-right",
            controlValidate: "validateRegis",
            iconSpan: "icon-registro las la-map-marked-alt",
            columns: "col-lg-4",
            id: "numDir",
            type: "text",
            placeHolder: "*Número",
            maxlength: 5,
            // numericKeyPress: true,
            methodChange: this.changeNumDir.bind(this)
        };
        
        this.configOcultar_dir_exacta = {
            controlValidate: "form-check-input",
            iconSpan: "icon-registro-checkbox las la-eye-slash",
            columns: "col-lg-12",
            id: "ocultarDirExacta",
            type: "checkbox",
            formGroup: "d-flex align-items-center justify-content-between",
            labelClass: "custom-control custom-checkbox",
            indicator: "custom-control-indicator",
            descriptionClass: "custom-control-description",
            labelDescription: " No mostrar dirección exacta públicamente",
            methodChange: this.changeOcultarDireccionExacta.bind(this)
        };
        
        this.configcheckbok_contrato_municipal = {
            controlValidate: "form-check-input",
            iconSpan: "icon-registro-checkbox las la-landmark",
            columns: "col-lg-12",
            id: "contratoMunicipal",
            type: "checkbox",
            formGroup: "d-flex align-items-center justify-content-between",
            labelClass: "custom-control custom-checkbox",
            indicator: "custom-control-indicator",
            descriptionClass: "custom-control-description",
            labelDescription: " ¿Tenéis contrato de servicio municial?",
            methodChange: this.changeContratoMunicipal.bind(this)
        };
        
        this.configMostrar_rrss = {
            controlValidate: "form-check-input",
            iconSpan: "icon-registro-checkbox las la-share-alt",
            columns: "col-lg-12",
            id: "ocultarDirExacta",
            type: "checkbox",
            formGroup: "d-flex align-items-center justify-content-between",
            labelClass: "custom-control custom-checkbox",
            indicator: "custom-control-indicator",
            descriptionClass: "custom-control-description",
            labelDescription: " Añadir redes sociales",
            methodChange: this.changeMostrarRRSS.bind(this)
        };
        this.configDirNoExactaText = {
            inlineIcon: "form-control-inline-icon inline-icon-right",
            controlValidate: "validateRegis",
            iconSpan: "icon-registro las la-home",
            columns: "col-lg-12",
            id: "direccionNoExacta",
            type: "text",
            placeHolder: "La dir se mostrará así",
            title: "Se mostrará así la dirección:",
            readOnly: true,
            methodChange: this.changeDireccionNoExacta.bind(this)
        };
        
        
        this.configMotivoOcultarDir = {
            inlineIcon: "form-control-inline-icon inline-icon-right",
            iconSpan: "icon-registro las la-question",
            controlValidate: "validateRegis",
            columns: "col-lg-12",
            id: "motivoOcultarDir",
            formGroup: "",
            rows: "3",
            placeHolder: "¿Por qué se oculta? (no es publico, nos ayuda a mejorar el servicio)",
            methodChange: this.changeMotivoOcultarDir.bind(this)
        };
        
        this.facebook = {
            inlineIcon: "form-control-inline-icon inline-icon-right",
            controlValidate: "validateRegis",
            iconSpan: "icon-registro lab la-facebook-f",
            columns: "col-lg-12",
            id: "facebook",
            type: "text",
            placeHolder: "Facebook",
            methodChange: this.changeFacebook.bind(this)
        };
        
        this.instagram = {
            inlineIcon: "form-control-inline-icon inline-icon-right",
            controlValidate: "validateRegis",
            iconSpan: "icon-registro lab la-instagram",
            columns: "col-lg-12",
            id: "instagram",
            type: "text",
            placeHolder: "Instagram",
            methodChange: this.changeInstagram.bind(this)
        };
        
        this.twitter = {
            inlineIcon: "form-control-inline-icon inline-icon-right",
            controlValidate: "validateRegis",
            iconSpan: "icon-registro lab la-twitter",
            columns: "col-lg-12",
            id: "twitter",
            type: "text",
            placeHolder: "Twitter",
            methodChange: this.changeTwitter.bind(this)
        };
        
        this.realizaEnvios = {
            controlValidate: "form-check-input",
            iconSpan: "icon-registro-checkbox las la-shipping-fast",
            columns: "col-lg-12",
            id: "realizaEnvios",
            type: "checkbox",
            formGroup: "d-flex align-items-center justify-content-between",
            labelClass: "custom-control custom-checkbox",
            indicator: "custom-control-indicator",
            descriptionClass: "custom-control-description",
            labelDescription: " ¿Realiza envios?",
            methodChange: this.changeRealizaEnvios.bind(this)
        };
        
        
        this.colaboradorNombre = {
            inlineIcon: "form-control-inline-icon inline-icon-right",
            controlValidate: "validateRegis",
            iconSpan: "icon-registro las la-phones",
            columns: "col-lg-11",
            id: "colaboradorNombre_0",
            type: "text",
            placeHolder: "*Nombre",
            methodChange: this.changeColaboradorNombre.bind(this)
        };
        
        this.colaboradorEmail = {
            inlineIcon: "form-control-inline-icon inline-icon-right",
            controlValidate: "validateRegis",
            iconSpan: "icon-registro las la-phones",
            columns: "col-lg-11 ",
            id: "colaboradorEmail_0",
            type: "text",
            placeHolder: "*Email",
            methodChange: this.changeColaboradorEmail.bind(this)
        };
        
        this.colaboradorTelefono = {
            inlineIcon: "form-control-inline-icon inline-icon-right",
            controlValidate: "validateRegis",
            iconSpan: "icon-registro las la-phones",
            columns: "col-lg-10 col-tel",
            id: "colaboradorTelefono_0",
            type: "text",
            placeHolder: "*Teléfono/Móvil",
            maxlength: 9,
            numericKeyPress: true,
            methodChange: this.changeTelefono.bind(this)
        };
        
        this.colaboradorFuncion = {
            inlineIcon: "form-control-inline-icon inline-icon-right",
            controlValidate: "validateRegis",
            iconSpan: "icon-registro las la-phones",
            columns: "col-lg-11 ",
            id: "colaboradorFuncion_0",
            type: "text",
            placeHolder: "*Función (Socio, gestión de animales,...)",
            methodChange: this.changeColaboradorFuncion.bind(this)
        };
        
        this.url = {
            inlineIcon: "form-control-inline-icon inline-icon-right",
            controlValidate: "validateRegis",
            iconSpan: "icon-registro las la-globe",
            columns: "col-lg-12",
            id: "url",
            type: "text",
            placeHolder: "Página web",
            methodChange: this.changeURL.bind(this)
        };
        
        this.textArea = {
            inlineIcon: "form-control-inline-icon inline-icon-right",
            iconSpan: "icon-registro las la-file-alt",
            controlValidate: "validateRegis",
            columns: "col-lg-12",
            id: "descripcion",
            formGroup: "",
            rows: "8",
            placeHolder: "Cuenta cosas sobre vosotros para que la gente pueda conoceros mejor",
            methodChange: this.changeDescripcion.bind(this)
        };
        
        this.EventWaitBlock = this.EventWaitBlock.bind(this);
        this.clear = this.clear.bind(this);
        this.handleOkPolitica = this.handleOkPolitica.bind(this);
        this.validarColaborador = this.validarColaborador.bind(this);
        
    }
    
    handleOkPolitica(checked) {
        this.setState({
            okPolitica: checked
        });
    }
    
    changeName(value) {
        this.setState({
            name: value
        });
    }
    
    changeTipoEntidad(tipo) {
        this.setState({
            tipoEntidad: tipo[0]
        })
    }
    
    changeOtroTipoEntidad(value) {
        this.setState({
            otroTipoEntidad: value
        });
    }
    
    changeNif(value) {
        this.setState({
            // nif: value.toUpperCase()
            nif: value
        });
        
        // value = value.toUpperCase();
        // let nif = $('#nif');
        // nif.val(value);
        // if (value.length > 0) {
        //     if (value.length === 9) {
        //         nif.removeClass('formInputError');
        //         nif.addClass("blink");
        //         if (!this.validateNif(value)) {
        //             Alert.warning('NIF incorrecto: ', {
        //                 position: 'top-right',
        //                 effect: 'slide',
        //                 timeout: 3000,
        //                 customFields: {
        //                     messageItem: 2,
        //                     showIconClosed: true
        //                 }
        //             });
        //             nif.addClass('formInputError');
        //         }
        //         nif.removeClass("blink");
        //     } else {
        //         if (nif.hasClass("formInputError")) {
        //             nif.removeClass('formInputError');
        //         }
        //         if (nif.hasClass("blink")) {
        //             nif.removeClass("blink");
        //         }
        //     }
        // }
    }
    
    changePassword(value) {
        this.setState({
            password: value
        });
    }
    
    changeEmail(value) {
        this.setState({
            email: value
        });
        if (!!(value.toLowerCase().includes("hotmail") || value.toLowerCase().includes("outlook"))) {
            //console.log("email ES outlook o hotmail");
        } else {
            //console.log("email es otro servicio");
        }
        
        
        this.setState({
            emailIsHotmail: !!(value.toLowerCase().includes("hotmail") || value.toLowerCase().includes("outlook"))
        })
    }
    
    changeCodPostal(value) {
        
        let codPostal = $('#codPostal');
        if (value.length > 0) {
            if (value.length === 5) {
                codPostal.removeClass('formInputError');
                codPostal.addClass("blink");
                //Pides información bajo un código postal.
                this.loadConfig("cod_postal", value);
            } else {
                this.setState({
                    address: {}
                });
            }
        }
        this.setState({
            codPostal: value
        });
    }
    
    blurCodPostal(value) {
        let codPostal = $('#codPostal');
        if (codPostal.val().length === 0) {
            this.setState({
                address: {}
            });
        }
    }
    
    
    changeLocalidad(value) {
        this.setState({
            localidad: value
        });
    }
    
    changeDireccionNoExacta(value) {
        this.setState({
            direccionNoExacta: value
        });
    }
    
    changeProvincia(value) {
        this.setState({
            provincia: value
        });
    }
    
    changeDireccion(value) {
        this.setState({
            direccion: value
        });
    }
    
    
    changeNumDir(value) {
        this.setState({
            numDir: value
        })
    }
    
    changeOcultarDireccionExacta(value) {
        this.setState({
            ocultarDireccionExacta: value
        });
    }
    
    changeContratoMunicipal(value) {
        this.setState({
            contratoMunicipal: value
        });
    }
    
    changeMostrarRRSS(value) {
        this.setState({
            mostrarRRSS: value
        });
    }
    
    
    changeMotivoOcultarDir(value) {
        this.setState({
            motivoOcultarDir: value
        });
    }
    
    changeFacebook(value) {
        this.setState({
            facebook: value
        });
    }
    
    changeInstagram(value) {
        this.setState({
            instagram: value
        });
    }
    
    changeTwitter(value) {
        this.setState({
            twitter: value
        });
    }
    
    changeURL(value) {
        this.setState({
            URL: value
        });
    }
    
    
    changeRealizaEnvios(value) {
        this.setState({
            realizaEnvios: value
        });
    }
    
    changeDescripcion(value) {
        this.setState({
            descripcion: value
        });
    }
    
    changeTelefono(value, elementId) {
        var deshabilitar = false;
        let splitId = elementId.split("_");
        if (splitId.length > 1) {
            let position = splitId[1];
            let colaboradores = this.state.colaboradores;
            let telefono = colaboradores[position];
            if (telefono === "") {
                if (telefono.WhatsApp) {
                    deshabilitar = true;
                }
                telefono = '{"telefono": ' + value.toString() + ', "WhatsApp": false}';
                colaboradores[position] = JSON.parse(telefono);
            } else {
                if (/^((\+34){0,1})+([6-7]{1})+([0-9]{2})+( ){0,1}([0-9]{2})+( ){0,1}([0-9]{2})+( ){0,1}([0-9]{2})$/i.test(telefono.telefono)) {
                    telefono.WhatsApp = false;
                    deshabilitar = true;
                }
                telefono.telefono = value;
                colaboradores[position] = telefono;
                
            }
            this.setState({
                colaboradores: colaboradores
            });
            if (deshabilitar) {
                this.whatsappEvent(position);
            }
        }
    }
    
    changeColaboradorNombre(value, elementId) {
        let splitId = elementId.split("_");
        if (splitId.length > 1) {
            let position = splitId[1];
            let colaboradores = this.state.colaboradores;
            let colaborador = colaboradores[position];
            colaborador.nombre = value;
            colaboradores[position] = colaborador;
            this.setState({
                colaboradores: colaboradores
            });
        }
    }
    
    changeColaboradorEmail(value, elementId) {
        
        let splitId = elementId.split("_");
        if (splitId.length > 1) {
            let position = splitId[1];
            let colaboradores = this.state.colaboradores;
            let colaborador = colaboradores[position];
            colaborador.email = value;
            colaboradores[position] = colaborador;
            this.setState({
                colaboradores: colaboradores
            });
        }
    }
    
    changeColaboradorFuncion(value, elementId) {
        
        let splitId = elementId.split("_");
        if (splitId.length > 1) {
            let position = splitId[1];
            let colaboradores = this.state.colaboradores;
            let colaborador = colaboradores[position];
            colaborador.funcion = value;
            colaboradores[position] = colaborador;
            this.setState({
                colaboradores: colaboradores
            });
        }
    }
    
    loadConfig(parameter, config) {
        let myparam = {};
        myparam[parameter] = config;
        let that = this;
        $.ajax({
                //Cambiar a type: POST si necesario
                type: "GET",
                //Datos que se envian
                data: myparam,
                // Formato de datos que se espera en la respuesta
                dataType: "json",
                // Asincronía.
                async: true,
                // URL a la que se enviará la solicitud Ajax
                url: "/api/utils/GeocodeByCodPostal",
            })
            .done(function (data, textStatus, jqXHR) {
                that.setState({
                    address: data,
                    localidad: data.municipio,
                    provincia: data.provincia
                });
                $('.blink').removeClass("blink");
            })
            .fail(function (jqXHR, textStatus, errorThrown) {
                let errorStr;
                if (typeof jqXHR.responseJSON === "object" && jqXHR.responseJSON.error !== undefined) {
                    errorStr = jqXHR.responseJSON.error.map(err => err.msg).join(', ').replace(/,(?!.*,)/gmi, ' y')
                } else {
                    errorStr = jqXHR.responseJSON ? jqXHR.responseJSON : "Hubo un error inesperado al buscar el código postal :(";
                }
                
                if (console && console.log) {
                    //console.log("La solicitud a fallado: " + errorStr);
                }
                
                Alert.warning('Error en el código postal: ' + errorStr, {
                    position: 'top-right',
                    effect: 'slide',
                    timeout: 6000,
                    customFields: {
                        messageItem: 2,
                        showIconClosed: true,
                        icon: "las la-2x la-exclamation-triangle"
                    }
                });
            });
    }
    
    validateEmail(email) {
        let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }
    
    validateNif(value) {
        
        const validChars = 'TRWAGMYFPDXBNJZSQVHLCKET';
        const nifRexp = /^[0-9]{8}[TRWAGMYFPDXBNJZSQVHLCKE]{1}$/i;
        const nieRexp = /^[XYZ]{1}[0-9]{7}[TRWAGMYFPDXBNJZSQVHLCKE]{1}$/i;
        const str = value.toString().toUpperCase();
        
        if (!nifRexp.test(str) && !nieRexp.test(str)) return false;
        
        const nie = str
            .replace(/^[X]/, '0')
            .replace(/^[Y]/, '1')
            .replace(/^[Z]/, '2');
        
        const letter = str.substr(-1);
        const charIndex = parseInt(nie.substr(0, 8)) % 23;
        
        return validChars.charAt(charIndex) === letter;
    }
    
    isUrlValid(userInput) {
        var res = userInput.match(/^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/g);
        if (res === null)
            return false;
        else
            return true;
    }
    
    imageChange(id, data) {
        this.setState({
            imageData: data
        });
    }
    
    Registrar(e) {
        //Comprobar que todos los campos son correctos.
        let errorMessage = "";
        let name = $('#name');
        let nif = $('#nif');
        let password = $('#password');
        let email = $('#email');
        let codPostal = $('#codPostal');
        let direccion = $('#direccion');
        let numDir = $("#numDir");
        // let telefono = $('#colaboradorTelefono_0');
        // let colaboradores = $('[id*=colaborador]');
        let url = $('#url');
        let logo = $('#imgLogo');
        let ocultarDirExacta = $('#ocultarDirExacta');
        let motivoOcultarDir = $('#motivoOcultarDir');
        let otroTipoEntidad = $('#otroTipoEntidad');
        let tipoEntidad = $('#tipoEntidad > div');
        
        /* Validate name */
        if (name.val() === "") {
            name.removeClass('formInputError').addClass('formInputError');
            errorMessage += errorMessage === "" ? "Nombre protectora" : ", nombre protectora";
        } else {
            name.removeClass('formInputError')
        }
        /* --- End validate name --- */
        
        
        if (this.state.tipoEntidad) {
            if (this.state.tipoEntidad === "Otro" && (!this.state.otroTipoEntidad || this.state.otroTipoEntidad.trim() === "")) {
                otroTipoEntidad.removeClass('formInputError').addClass('formInputError');
                errorMessage += errorMessage === "" ? "El tipo de entidad" : ", el tipo de entidad";
            } else {
                otroTipoEntidad.removeClass('formInputError')
            }
            /* --- End validate dirección noexata--- */
            tipoEntidad.removeClass('formInputError')
        } else {
            tipoEntidad.removeClass('formInputError').addClass('formInputError');
            errorMessage += errorMessage === "" ? "El tipo de entidad" : ", el tipo de entidad";
        }
        
        
        /* Validate NIF/CIF */
        // if (nif.val() === "") {
        //     nif.removeClass('formInputError').addClass('formInputError');
        //     if (errorMessage === "") {
        //         errorMessage = "NIF/CIF";
        //     } else {
        //         errorMessage += ", NIF/CIF";
        //     }
        // } else {
        // if (!this.validateNif(nif.val())) {
        //     nif.removeClass('formInputError').addClass('formInputError');
        //     if (errorMessage === "") {
        //         errorMessage = "NIF/CIF no válido";
        //     } else {
        //         errorMessage += ", NIF/CIF no válido";
        //     }
        // } else {
        nif.removeClass('formInputError')
        // }
        // }
        /* --- End validate NIF/CIF --- */
        
        /* Validate password */
        if (password.val() === "") {
            password.removeClass('formInputError').addClass('formInputError');
            if (errorMessage === "") {
                errorMessage = "Contraseña";
            } else {
                errorMessage += ", contraseña";
            }
        } else {
            password.removeClass('formInputError')
        }
        /* --- End validate password --- */
        
        /* Validate email (Required) */
        if (email.val() === "") {
            email.removeClass('formInputError').addClass('formInputError');
            if (errorMessage === "") {
                errorMessage = "Email";
            } else {
                errorMessage += ", email";
            }
        } else {
            if (!this.validateEmail(email.val().trim())) {
                email.removeClass('formInputError').addClass('formInputError');
                if (errorMessage === "") {
                    errorMessage = "Email no válido";
                } else {
                    errorMessage += ", email no válido";
                }
            } else {
                email.removeClass('formInputError')
            }
        }
        /* --- End validate email --- */
        
        /* Validate codPostal */
        if (codPostal.val() === "") {
            codPostal.removeClass('formInputError').addClass('formInputError');
            errorMessage += errorMessage === "" ? "Código postal" : ", código postal";
        } else {
            if (codPostal.val().length != 5) {
                errorMessage += errorMessage === "" ? "Código postal no válido" : ", código postal no válido";
            }
            codPostal.removeClass('formInputError')
        }
        /* --- End validate codPostal --- */
        
        /* Validate dirección */
        // if (direccion.val() === "") {
        //     direccion.removeClass('formInputError').addClass('formInputError');
        //     errorMessage += errorMessage === "" ? "Dirección" : ", dirección";
        // } else {
        //     direccion.removeClass('formInputError')
        // }
        /* --- End validate dirección --- */
        
        /* Validate dirección */
        if (numDir.val() === "") {
            numDir.removeClass('formInputError').addClass('formInputError');
            if (errorMessage === "") {
                errorMessage = "Número de la dirección";
            } else {
                errorMessage += ", número de la dirección";
            }
        } else {
            numDir.removeClass('formInputError')
        }
        /* --- End validate dirección --- */
        
        /* Validate dirección no exacta */
        if (this.state.ocultarDireccionExacta) {
            if (this.state.motivoOcultarDir === "") {
                motivoOcultarDir.removeClass('formInputError').addClass('formInputError');
                errorMessage += errorMessage === "" ? "Motivo de ocultar la direción" : ", motivo de ocultar la direción";
            } else {
                motivoOcultarDir.removeClass('formInputError')
            }
            /* --- End validate dirección noexata--- */
        }
        
        /* Validate teléfono */
        // if (telefono.val() === "") {
        //     telefono.removeClass('formInputError').addClass('formInputError');
        //     if (errorMessage === "") {
        //         errorMessage = "Teléfono/Móvil";
        //     } else {
        //         errorMessage += ", teléfono/Móvil";
        //     }
        // } else {
        //     if (telefono.val().length !== 9) {
        //         if (errorMessage === "") {
        //             errorMessage = "Teléfono/Móvil no válido";
        //         } else {
        //             errorMessage += ", teléfono/Móvil no válido";
        //         }
        //     }
        //     telefono.removeClass('formInputError')
        // }
        /* --- End validate teléfono --- */
        
        
        /* --- Validate colaborador 0 --- */
        if (this.state.colaboradores.length === 0) {
            errorMessage += errorMessage === "" ? "Datos del primer colaborador" : ", datos del primer colaborador";
            $('#colaboradorNombre_0').removeClass('formInputError').addClass('formInputError');
            $('#colaboradorEmail_0').removeClass('formInputError').addClass('formInputError');
            $('#colaboradorTelefono_0').removeClass('formInputError').addClass('formInputError');
            $('#colaboradorFuncion_0').removeClass('formInputError').addClass('formInputError');
        }
        
        this.state.colaboradores.forEach((colab, index) => {
            errorMessage = this.validarColaborador(colab, index, errorMessage);
        })
        
        
        /* --- End validate colaborador 0 --- */
        
        // if (this.state.colaboradores.length > 1) {
        //     this.state.colaboradores.forEach((e) => {
        //         var telefono_aux = $("#" + e.id);
        //         if (e.id !== "telefono_0") {
        //             if (telefono_aux.val() !== "") {
        //                 if (telefono_aux.val().length !== 9) {
        //                     if (errorMessage === "") {
        //                         errorMessage = "Teléfono/Móvil (" + e.id.split("_")[1] + "no válido)";
        //                     } else {
        //                         errorMessage += ", teléfono/Móvil (" + e.id.split("_")[1] + "no válido)";
        //                     }
        //                 }
        //                 telefono.removeClass('formInputError')
        //             }
        //         }
        //     })
        // }
        
        /* Validate URL */
        // if ((Object.entries(url)>0) && url.val().length > 0) {
        //     if (!this.isUrlValid(url.val())) {
        //         url.removeClass('formInputError').addClass('formInputError');
        //         errorMessage += errorMessage === "" ? "Página web no válida" : ", página web no válida";
        //     } else {
        //         url.removeClass('formInputError');
        //     }
        // }
        /* --- End validate URL --- */
        
        /* Validate Imagen Icono */
        // if (Object.keys(this.state.imageData).length === 0) {
        //     logo.removeClass('formInputError').addClass('formInputError');
        //     if (errorMessage === "") {
        //         errorMessage = "Logo/Icono empresa";
        //     } else {
        //         errorMessage += ", Logo/Icono empresa";
        //     }
        // } else {
        //     logo.removeClass('formInputError');
        // }
        /* --- End Imagen Icono URL --- */
        
        Alert.closeAll();
        if (errorMessage !== "") {
            e.preventDefault();
            Alert.warning('Los siguientes campos son obligatorios: <br> ' + errorMessage, {
                position: 'top-right',
                effect: 'slide',
                timeout: 600000,
                customFields: {
                    messageItem: 2,
                    showIconClosed: true,
                    icon: "las la-2x la-exclamation-triangle"
                }
            });
        } else {
            e.preventDefault();
            this.props.changeWaitBlock(true);
        }
    }
    
    validarColaborador(colaborador, index, errorMessage) {
        let errorTodo = true;
        let errorMessageAux = errorMessage;
        if (!colaborador.nombre || colaborador.nombre === "") {
            $('#colaboradorNombre_' + index).removeClass('formInputError').addClass('formInputError');
            errorMessage += errorMessage === "" ? "Nombre del colaborador " + (index + 1) : ", nombre del colaborador " + (index + 1);
        } else {
            errorTodo &= false;
            $('#colaboradorNombre_' + index).removeClass('formInputError')
        }
        
        if (!colaborador.email || colaborador.email === "") {
            $('#colaboradorEmail_' + index).removeClass('formInputError').addClass('formInputError');
            errorMessage += errorMessage === "" ? "Email del colaborador " + (index + 1) : ", email del colaborador " + (index + 1);
        } else {
            errorTodo &= false;
            $('#colaboradorEmail_' + index).removeClass('formInputError')
        }
        
        if (!colaborador.telefono || colaborador.telefono === "") {
            $('#colaboradorTelefono_' + index).removeClass('formInputError').addClass('formInputError');
            errorMessage += errorMessage === "" ? "Teléfono/Móvil del colaborador " + (index + 1) : ", teléfono/Móvil del colaborador " + (index + 1);
        } else {
            errorTodo &= false;
            if (colaborador.telefono.length !== 9) {
                errorMessage += errorMessage === "" ? "Teléfono/Móvil no válido del colaborador " + (index + 1) : ", teléfono/Móvil no válido del colaborador " + (index + 1);
            }
            $('#colaboradorTelefono_' + index).removeClass('formInputError')
        }
        
        if (!colaborador.funcion || colaborador.funcion === "") {
            $('#colaboradorFuncion_' + index).removeClass('formInputError').addClass('formInputError');
            errorMessage += errorMessage === "" ? "Función del colaborador " + (index + 1) : ", función del colaborador " + (index + 1);
        } else {
            errorTodo &= false;
            $('#colaboradorFuncion_' + index).removeClass('formInputError')
        }
        
        if (errorTodo) {
            errorMessageAux += errorMessageAux === "" ? "Todos los datos del colaborador " + (index + 1) : ", todos los datos del colaborador " + (index + 1);
            return errorMessageAux;
        }
        return errorMessage
    }
    
    clear() {
        $('#name').val("");
        $('#nif').val("");
        $('#password').val("");
        $('#email').val("");
        $('#codPostal').val("");
        $('#direccion').val("");
        $('#numDir').val("");
        $('#telefono_0').val("");
        $('[id*=telefono]').val("");
        $('#url').val("");
        $('#instagram').val("");
        $('#twitter').val("");
        $('#descripcion').val("");
        $('#motivoOcultarDir').val("");
        $('.la-whatsapp')/*.addClass("icon-registro-whatsapp_telephone-disabled");*/
    }
    
    EventWaitBlock(event) {
        
        if (event === "go") {
            this.props.signUp(this.state);
            // } else if (event > 1 && event < 100) {
            //     if (Object.keys(this.state.imageData).length !== 0) {
            //         this.props.sendImage(this.state, this.props.reducerAccess);
            //     }
        } else {
            if (this.props.stepWaitBlock === 200 || this.props.stepWaitBlock === 201) {
                Alert.success('Registrado correctamente. Revise su bandeja de entreda para verificar el email.', {
                    position: 'top-right',
                    effect: 'slide',
                    timeout: 6000,
                    customFields: {
                        messageItem: 2,
                        showIconClosed: true,
                        icon: "las la-2x la-thumbs-up"
                    }
                });
                //Initial scrolls
                let element = $("body");
                if (element.length !== 0) {
                    //console.log("Haciendo scrollTop");
                    $('body,html').stop(true, true).animate({scrollTop: element.offset().top}, 0);
                }
                this.clear();
                
                this.setState(this.initialState);
                this.setState({
                    colaboradores: [""]
                });
                browserHistory.push(this.props.thanksPage);
            } else {
                Alert.error('Error: ' + this.props.errorWaitBlock, {
                    position: 'top-right',
                    effect: 'slide',
                    timeout: 6000,
                    customFields: {
                        messageItem: 2,
                        showIconClosed: true,
                        icon: "las la-2x la-exclamation-triangle"
                    }
                });
            }
            this.props.changeStepWaitBlock(0);
            this.props.changeWaitBlock(false);
        }
        
    }
    
    goLogin() {
        let animationEnd = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';
        $('.page-login').removeClass('animated-400ms fadeIn').addClass('animated-400ms fadeOut').one(animationEnd, () => {
            browserHistory.push(PATH_BUSCADOR_ANIMALES_ADMIN);
        });
    }
    
    addColaborador(nombreAdd, emailAdd, telefonoAdd, whatsappAdd, funcionAdd) {
        
        let colaboradores = this.state.colaboradores;
        
        const nuevaColaborador = {
            nombre: "",
            email: "",
            telefono: "",
            WhatsApp: true,
            funcion: ""
        }
        
        // telefonos.push(JSON.parse('{ "telefono": "' + telefonoAdd + '", "WhatsApp": ' + whatsappAdd + ' }'));
        colaboradores.push(nuevaColaborador);
        
        this.setState({
            colaboradores: colaboradores
        });
        
        // let element = $("#telefono_0");
        // if (element.length !== 0) {
        //     console.log("Haciendo scrollTop");
        //     $('body,html').stop(true, true).animate({
        //         scrollTop: element.offset().top
        //     }, 0);
        // }
    }
    
    removeTelephone(position) {
        
        let telephones = this.state.colaboradores;
        
        if (telephones.length > 0) {
            telephones.splice(position, 1);
        }
        
        this.setState({
            colaboradores: telephones
        });
    }
    
    whatsappEvent(position) {
        
        let telephones = this.state.colaboradores;
        
        if (telephones.length > 0) {
            let colaboradores = this.state.colaboradores;
            let telefono = colaboradores[position];
            if (telefono.telefono !== "") {
                if (/^((\+34){0,1})+([6-7]{1})+([0-9]{2})+( ){0,1}([0-9]{2})+( ){0,1}([0-9]{2})+( ){0,1}([0-9]{2})$/i.test(telefono.telefono)) {
                    Alert.closeAll();
                    if (!telefono.WhatsApp) {
                        $('#whatsapp_' + position).removeClass("icon-registro-whatsapp_telephone-disabled");
                        Alert.info('Whatsapp habilitado para: ' + telefono.telefono, {
                            position: 'top-right',
                            effect: 'slide',
                            timeout: 5000,
                            customFields: {
                                messageItem: 2,
                                showIconClosed: true,
                                icon: "lab la-whatsapp la-2x"
                            }
                        });
                    } else {
                        $('#whatsapp_' + position).addClass("icon-registro-whatsapp_telephone-disabled");
                        Alert.info('Whatsapp deshabilitado para: ' + telefono.telefono, {
                            position: 'top-right',
                            effect: 'slide',
                            timeout: 5000,
                            customFields: {
                                messageItem: 2,
                                showIconClosed: true,
                                icon: "lab la-whatsapp la-2x"
                            }
                        });
                    }
                    telefono.WhatsApp = !telefono.WhatsApp;
                    colaboradores[position] = telefono;
                } else {
                    $('#whatsapp_' + position).addClass("icon-registro-whatsapp_telephone-disabled");
                }
            }
            this.setState({
                colaboradores: colaboradores
            });
        }
    }
    
    createColaborador() {
        
        return this.state.colaboradores.map((colaborador, index) => {
            if (index !== 0) {
                
                
                let _colaboradorNombre_extra = Object.assign({}, this.colaboradorNombre);
                _colaboradorNombre_extra.id = "colaboradorNombre_" + (index);
                _colaboradorNombre_extra.columns = "col-lg-10 col-tel";
                let initialNombre = (colaborador.nombre === undefined ? "" : colaborador.nombre);
                
                
                let classTelephone0 = "lab la-whatsapp icon-registro-whatsapp_telephone";
                if (!colaborador.WhatsApp) {
                    classTelephone0 += " icon-registro-whatsapp_telephone-disabled";
                }
                
                // let _telefono_extra = Object.assign({}, this.telefono_extra);
                let _colaboradorTelefono_extra = Object.assign({}, this.colaboradorTelefono);
                _colaboradorTelefono_extra.id = "colaboradorTelefono_" + (index);
                // _telefono_extra.placeHolder = "Teléfono/Móvil extra";
                // this.whatsappID = "whatsapp_" + (index);
                let initialTelefono = (colaborador.telefono === undefined ? "" : colaborador.telefono);
                
                let _colaboradorEmail_extra = Object.assign({}, this.colaboradorEmail);
                _colaboradorEmail_extra.id = "colaboradorEmail_" + (index);
                let initialEmail = (colaborador.email === undefined ? "" : colaborador.email);
                
                let _colaboradorFuncion_extra = Object.assign({}, this.colaboradorFuncion);
                _colaboradorFuncion_extra.id = "colaboradorFuncion_" + (index);
                let initialFuncion = (colaborador.funcion === undefined ? "" : colaborador.funcion);
                
                
                return (
                    <div key={"colaborador_" + (index)}>
                        <div className="page-login-colaboradores__separator"><span>+</span></div>
                        <div className="row justify-content-center animationShowTelephone" key={index}>
                            
                            <Input configInput={_colaboradorNombre_extra} initialText={initialNombre}/>
                            <div className="col-1 col-tel-cancel" onClick={() => this.removeTelephone(index)}>
                                <span className="las la-times icon-registro-delete_telephone"></span>
                            </div>
                            <Input configInput={_colaboradorEmail_extra} initialText={initialEmail}/>
                            <Input configInput={_colaboradorTelefono_extra} initialText={initialTelefono}/>
                            <div className="col-1 col-tel-whatsapp" onClick={() => this.whatsappEvent(index)}>
                                <span id={"whatsapp_" + (index)} className={classTelephone0}></span>
                            </div>
                            <Input configInput={_colaboradorFuncion_extra} initialText={initialFuncion}/>
                        </div>
                    </div>
                
                );
            }
        });
    }
    
    render() {
        let show = false;
        if (this.props.tiposEntidad !== undefined && Object.keys(this.props.tiposEntidad).length !== 0) {
            show = true;
        }
        return (
            <div>
                {show &&
                    <div>
                        <Head
                            previousPath={"RegistroProtectoraPage"}
                        />
                        {this.props.showWaitBlock &&
                            <WaitBlock
                                message={"Guardando datos..."}
                                methodChange={this.EventWaitBlock}
                            />
                        }
                        <div className="page-login main-content">
                            <div className="container">
                                <div className="page-login__wrap">
                                    <h2 className="page-signup__heading">{this.props.title}</h2>
                                    <p className="page-login__description">
                                        <br/>
                                        Estás a un pequeño paso de mejorar las adopciones de tu refugio o asociación
                                    </p>
                                    <div>
                                        <Timeline
                                            info={this.info}
                                        />
                                    </div>
                                    <div>
                                        
                                        <form action="#" className="page-login__form">
                                            <div className="page-login__separator"><span>Sobre el centro</span></div>
                                            
                                            <div className="row justify-content-center">
                                                <Input
                                                    configInput={this.name}
                                                />
                                            </div>
                                            <div className="row justify-content-center">
                                                <SimpleSelect
                                                    configSearch={this.configTipoEntidad}
                                                    data={this.props.tiposEntidad.map((tipo) => {
                                                        return tipo.text;
                                                    })}
                                                />
                                            
                                            
                                            </div>
                                            {this.state.tipoEntidad === "Otro" &&
                                                <div className="row justify-content-center">
                                                    <Input
                                                        configInput={this.configOtroTipoEntidad}
                                                        initialText={this.state.otroTipoEntidad}
                                                    />
                                                </div>
                                            }
                                            {/*<div className="row justify-content-center">*/}
                                            {/*    <Input*/}
                                            {/*        configInput={this.configcheckbok_contrato_municipal}*/}
                                            {/*        initialText={this.state.contratoMunicipal}*/}
                                            {/*    />*/}
                                            {/*</div>*/}
                                            {/*<div className="row justify-content-center">*/}
                                            {/*    <Input*/}
                                            {/*        configInput={this.nif}*/}
                                            {/*    />*/}
                                            {/*</div>*/}
                                            <div className="page-login__separator"><span>Inicio de sesión</span></div>
                                            <div className="page-login-text">
                                                
                                                <div className="page-login-titulo">Con esto podrás iniciar sesión en la
                                                    plataforma, recibir notificaciones y mensajes de los posibles
                                                    adoptantes
                                                </div>
                                                <div className="page-login-subtitulo">No son datos que pueda ver la
                                                    gente
                                                </div>
                                            </div>
                                            
                                            <div className="row justify-content-center">
                                                <Input
                                                    configInput={this.email}
                                                />
                                            </div>
                                            <div className="row justify-content-center">
                                                <InputPassword
                                                    configInput={this.password}
                                                />
                                            </div>
                                            <div className="page-login__separator"><span>¿Por dónde estáis?</span></div>
                                            
                                            <div className="page-login-text">
                                                
                                                <div className="page-login-titulo">Usamos la ubicación de tu refugio o
                                                    asociación para mejorar la experiencia en el buscador y acercar los
                                                    animales
                                                    a los posibles adoptantes
                                                </div>
                                            </div>
                                            <div className="page-login-subtitulo">En el panel de administración podrás
                                                añadir la calle si quires que sea pública
                                            </div>
                                            
                                            <div className="row justify-content-center">
                                                <Input
                                                    configInput={this.codPostal}
                                                />
                                            </div>
                                            {Object.keys(this.state.address).length !== 0 &&
                                                <div className="row justify-content-center animationShowAddress">
                                                    <Input
                                                        configInput={this.localidad}
                                                    />
                                                </div>
                                            }
                                            {Object.keys(this.state.address).length !== 0 &&
                                                <div className="row justify-content-center animationShowAddress">
                                                    <Input
                                                        configInput={this.provincia}
                                                    />
                                                </div>
                                            }
                                            {/*<div className="row justify-content-center">*/}
                                            {/*    <Input*/}
                                            {/*        configInput={this.direccion}*/}
                                            {/*    />*/}
                                            {/*    <Input*/}
                                            {/*        configInput={this.num_dir}*/}
                                            {/*    />*/}
                                            {/*</div>*/}
                                            {/*<div className="row justify-content-center">*/}
                                            {/*    <Input*/}
                                            {/*        configInput={this.configOcultar_dir_exacta}*/}
                                            {/*        initialText={this.state.ocultarDireccionExacta}*/}
                                            {/*    />*/}
                                            {/*    {this.state.ocultarDireccionExacta &&*/}
                                            {/*    <span id="direccionNoExacta" className="col-lg-12 form-group">Se mostrará así la dirección: <br/>*/}
                                            {/*        <span id="direccionNoExactaText">{this.state.direccionNoExacta}</span>*/}
                                            {/*    </span>*/}
                                            {/*    }*/}
                                            {/*</div>*/}
                                            {/*{this.state.ocultarDireccionExacta &&*/}
                                            {/*<InputTextarea*/}
                                            {/*    configTextArea={this.configMotivoOcultarDir}*/}
                                            {/*    initialText={this.state.motivoOcultarDir}*/}
                                            {/*/>*/}
                                            {/*}*/}
                                            {/*<Input*/}
                                            {/*    configInput={this.configMostrar_rrss}*/}
                                            {/*    initialText={this.state.mostrarRRSS}*/}
                                            {/*/>*/}
                                            {/*{this.state.mostrarRRSS &&*/}
                                            {/*<div>*/}
                                            {/*    <div className="row justify-content-center">*/}
                                            {/*        <Input*/}
                                            {/*            configInput={this.url}*/}
                                            {/*        />*/}
                                            {/*    </div>*/}
                                            {/*    <div className="row justify-content-center">*/}
                                            {/*        <Input*/}
                                            {/*            configInput={this.facebook}*/}
                                            {/*        />*/}
                                            {/*    </div>*/}
                                            {/*    <div className="row justify-content-center">*/}
                                            {/*        <Input*/}
                                            {/*            configInput={this.instagram}*/}
                                            {/*        />*/}
                                            {/*    </div>*/}
                                            {/*    <div className="row justify-content-center">*/}
                                            {/*        <Input*/}
                                            {/*            configInput={this.twitter}*/}
                                            {/*        />*/}
                                            {/*    </div>*/}
                                            {/*</div>*/}
                                            {/*}*/}
                                            
                                            {/*<div className="row justify-content-center">*/}
                                            {/*    <InputTextarea*/}
                                            {/*        configTextArea={this.textArea}*/}
                                            {/*    />*/}
                                            {/*</div>*/}
                                            {/*<div className="row justify-content-center">*/}
                                            {/*    <Input*/}
                                            {/*        configInput={this.realizaEnvios}*/}
                                            {/*    />*/}
                                            {/*</div>*/}
                                            
                                            {/*{this.state.ocultarDireccionExacta &&*/}
                                            {/*<InputTextarea*/}
                                            {/*    configTextArea={this.configMotivoOcultarDir}*/}
                                            {/*    initialText={this.state.motivoOcultarDir}*/}
                                            {/*/>*/}
                                            {/*}*/}
                                            {/*<Input*/}
                                            {/*    configInput={this.configMostrar_rrss}*/}
                                            {/*    initialText={this.state.mostrarRRSS}*/}
                                            {/*/>*/}
                                            {/*{this.state.mostrarRRSS &&*/}
                                            {/*<div>*/}
                                            {/*    <div className="row justify-content-center">*/}
                                            {/*        <Input*/}
                                            {/*            configInput={this.url}*/}
                                            {/*        />*/}
                                            {/*    </div>*/}
                                            {/*    <div className="row justify-content-center">*/}
                                            {/*        <Input*/}
                                            {/*            configInput={this.facebook}*/}
                                            {/*        />*/}
                                            {/*    </div>*/}
                                            {/*    <div className="row justify-content-center">*/}
                                            {/*        <Input*/}
                                            {/*            configInput={this.instagram}*/}
                                            {/*        />*/}
                                            {/*    </div>*/}
                                            {/*    <div className="row justify-content-center">*/}
                                            {/*        <Input*/}
                                            {/*            configInput={this.twitter}*/}
                                            {/*        />*/}
                                            {/*    </div>*/}
                                            {/*</div>*/}
                                            {/*}*/}
                                            
                                            {/*<div className="row justify-content-center">*/}
                                            {/*    <InputTextarea*/}
                                            {/*        configTextArea={this.textArea}*/}
                                            {/*    />*/}
                                            {/*</div>*/}
                                            {/*<div className="row justify-content-center">*/}
                                            {/*    <Input*/}
                                            {/*        configInput={this.realizaEnvios}*/}
                                            {/*    />*/}
                                            {/*</div>*/}
                                            <div className="page-login__separator"><span>Personas de contacto</span>
                                            </div>
                                            <div className="page-login-text">
                                                
                                                <div className="page-login-titulo">Añade una o más personas de contacto
                                                    para
                                                    que la
                                                    gente pueda comunicarse con vosotros (socios, colaboradores,
                                                    trabajadores,
                                                    voluntarios...)
                                                </div>
                                                <div className="page-login-subtitulo">Al habilitar el WhatsApp la gente
                                                    podrá
                                                    escribirte para pedir información
                                                </div>
                                            </div>
                                            <div className="row justify-content-center">
                                                
                                                <Input
                                                    configInput={this.colaboradorNombre}
                                                    initialText={this.state.colaboradores[0].nombre}
                                                />
                                                <Input
                                                    configInput={this.colaboradorEmail}
                                                    initialText={this.state.colaboradores[0].email}
                                                />
                                                <Input
                                                    configInput={this.colaboradorTelefono}
                                                    initialText={this.state.colaboradores[0].telefono}
                                                />
                                                <div className="col-lg-1 col-tel-whatsapp"
                                                     onClick={() => this.whatsappEvent(0)}>
                                            <span id="whatsapp_0"
                                                  className="lab la-whatsapp icon-registro-whatsapp_telephone"></span>
                                                </div>
                                                <Input
                                                    configInput={this.colaboradorFuncion}
                                                    initialText={this.state.colaboradores[0].funcion}
                                                />
                                            </div>
                                            {this.createColaborador()}
                                            <div className="row justify-content-center">
                                                <div className="col-lg-12">
                                                    <div className="form-group">
                                                        <button
                                                            onClick={() => this.addColaborador("", "", "", false, "")}
                                                            type="button"
                                                            className="btn btn-block boton_add-telephone">Añadir
                                                            colaborador
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="page-login__separator"><span>Más información</span></div>
                                            <div className="page-login-titulo">Podrás añadir más información desde el
                                                panel
                                                de administración, como el logo, una descripción y vuestra historia o
                                                tus
                                                redes sociales
                                            </div>
                                            {/*{this.state.loaded &&*/}
                                            {/*<div className="row justify-content-center">*/}
                                            {/*    <div className="page-login__separator"></div>*/}
                                            {/*    <p className="icono-protectora-text-head">Icono/logo de tu protectora</p>*/}
                                            {/*    <div className="page-login-titulo">Podrás añadirlo más tarde desde el panel de administración</div>*/}
                                            {/*<ImageDragAndDrop*/}
                                            {/*    elementId={"imgLogo"}*/}
                                            {/*    image={this.state.imageData}*/}
                                            {/*    imageChangeMethod={this.imageChange}*/}
                                            {/*/>*/}
                                            {/*</div>*/}
                                            {/*}*/}
                                            <div className="page-login__separator"></div>
                                            {this.props.showOkPolitica &&
                                                <div>
                                                    <PoliticaCheckButton onOkPolitica={this.handleOkPolitica}/>
                                                </div>
                                            }
                                            {this.state.emailIsHotmail &&
                                                <div className="page-login-text">
                                                    <div className={"sub-input-warning"}>Hemos experimentado problemas
                                                        con el
                                                        envio de correos a direcciones Hotmail/Outlook. Si es tu caso y
                                                        no
                                                        recibes el email
                                                        de confirmación en breve ponte en contacto con nosotros, por
                                                        favor.
                                                    </div>
                                                </div>
                                            }
                                            <div className="row justify-content-center">
                                                <div className="col-lg-12">
                                                    <div className="form-group mb-0">
                                                        <button
                                                            className="btn btn-primary btn-block page-login__submit-btn"
                                                            type="button"
                                                            onClick={this.Registrar}
                                                            disabled={this.props.showOkPolitica && !this.state.okPolitica}
                                                        >
                                                            Registrar
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                            {/*<footer className="page-login__form-footer">*/}
                                            {/*    <span>¿Ya estás registrado?</span>*/}
                                            {/*    <a href="#" onClick={() => this.goLogin()}*/}
                                            {/*       className="btn btn-outline-secondary page-login__signup-btn">Ir a*/}
                                            {/*        login</a>*/}
                                            {/*</footer>*/}
                                        </form>
                                    </div>
                                
                                </div>
                            </div>
                        </div>
                        <Alert stack={true} html={true} contentTemplate={AlertsConteiner}/>
                    </div>
                }
            </div>
        );
    }
    
    componentWillMount() {
        
        if (this.props.access.isLogin) {
            browserHistory.push(PATH_BUSCADOR_ANIMALES_ADMIN);
        }
        
        if (this.props.tiposEntidad === undefined || Object.keys(this.props.tiposEntidad).length === 0) {
            this.props.loadTiposEntidad();
        }
        
        //Initial scroll
        let element = $("body");
        if (element.length !== 0) {
            
            $('body,html').stop(true, true).animate({
                scrollTop: element.offset().top
            }, 0);
        }
        
        this.props.changeWaitBlock(false);
        this.props.changeStepWaitBlock(0);
        
    }
    
    componentDidMount() {
        
        //$('.page-login').addClass('animated-400ms fadeIn');
        $('.page-login').show();
        let animationEnd = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';
        
        if (!this.props.showHead) {
            $('.header-topbar').addClass('animated-400ms fadeInDown').one(animationEnd, () => {
                $('.header-topbar').removeClass('animated-400ms fadeInDown');
            });
            //$('.header-topbar').css("visibility", "visible");
        } else {
            $('.header-topbar').removeClass('animated-400ms fadeInDown');
            //$('.header-topbar').css("visibility", "visible");
        }
        
        if (!this.props.showFooter) {
            // $('.footer-default').addClass('animated-400ms fadeIn');
            $('.footer-default').show();
        } else {
            // $('.footer-default').removeClass('animated-400ms fadeIn');
            $('.footer-default').show();
        }
        
        this.setState({
            loaded: true
        })
        
        // $('#name').focus();
        
    }
    
    componentWillUpdate(nextProps, nextState, nextContext) {
        
        if (nextState.tipoEntidad) {
            this.configTipoEntidad = {
                ...this.configTipoEntidad,
                seleccionado: nextState.tipoEntidad
            };
        }
    }
    
    componentDidUpdate() {
        if (Object.keys(this.state.address).length !== 0) {
            $('#localidad').val(this.state.localidad);
            $('#provincia').val(this.state.provincia);
        }
        if (this.props.showWaitBlock && this.props.stepWaitBlock === 0) {
            $('#modal-container').removeClass('out').addClass("one");
        }
        
        if (this.state.ocultarDireccionExacta) {
            if (Object.keys(this.state.address).length !== 0) {
                $('#direccionNoExactaText').text("Zona de " + this.state.localidad + ", " + this.state.provincia);
            }
        }
        
        if (this.props.showWaitBlock) {
            $('body').addClass('modal-active');
        } else {
            $('body').removeClass('modal-active');
        }
    }
    
}

function mapStateToProps(state) {
    return {
        showHead: state.structureControl.showHead,
        showFooter: state.structureControl.showFooter,
        showWaitBlock: state.structureControl.showWaitBlock,
        stepWaitBlock: state.structureControl.stepWaitBlock,
        errorWaitBlock: state.structureControl.errorWaitBlock,
        // isLogin: state.reducerAccess.isLogin,
        access: state.access,
        tiposEntidad: state.filtersControl.tiposEntidad,
    }
}

//El primer parametro es el mapeo de las props y el segundo las acciones- luego se le coloca que componente se ejecuta
export default connect(mapStateToProps, {
    changeWaitBlock: showWaitBlock,
    changeStepWaitBlock,
    signUp,
    // sendImage,
    isLogin: checkIsLogin, loadTiposEntidad
})(RegistroProtectoraPage)
